import { render, staticRenderFns } from "./StopPermanentDebtDialog.vue?vue&type=template&id=d540e57c&"
import script from "./StopPermanentDebtDialog.vue?vue&type=script&lang=js&"
export * from "./StopPermanentDebtDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports